(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('Norma', Norma);

    Norma.$inject = ['$resource', 'DateUtils'];

    function Norma ($resource, DateUtils) {
        var resourceUrl =  'api/normas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaEmision = DateUtils.convertDateTimeFromServer(data.fechaEmision);
                        data.fechaPublicacion = DateUtils.convertDateTimeFromServer(data.fechaPublicacion);
                        data.fechaDOF = DateUtils.convertDateTimeFromServer(data.fechaDOF);
                        data.fechaSJFYG = DateUtils.convertDateTimeFromServer(data.fechaSJFYG);
                        data.fechaSJFGaceta = DateUtils.convertDateTimeFromServer(data.fechaSJFGaceta);
                        data.fechaFinVigencia = DateUtils.convertDateTimeFromServer(data.fechaFinVigencia);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete': {method: 'DELETE'},
            'index': {
                url: 'api/normas/index/:id',
                method: 'GET'
            },
            'historicos': {
                url: 'api/normas/:id/historicos',
                method: 'GET',
                isArray: true
            },
            'hacerVigente': {
                url: 'api/normas/:id/hacer-vigente',
                method: 'POST'
            },
            'vincular': {
                url: 'api/normas/:id/vincular',
                method: 'POST'
            },
            'desvincular': {
                url: 'api/normas/:id/desvincular',
                method: 'POST'
            },
            'buscarVinculables': {
                url: 'api/normas/buscar-vinculables',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
